// Copyright 2023, Imprivata, Inc.  All rights reserved.

export class AgentSection {
  systemData: string | undefined;
  endpointId: string | undefined;
}
